import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, useTheme } from '@mui/material';

import PlusIcon from '@/assets/icons/plus.svg?react';
import typography from '@/theme/typography';

const NewProcessButton: FC<{ onClick: () => void }> = ({ onClick }) => {
  const { spacing } = useTheme();
  const { t } = useTranslation('filters');

  return (
    <Button
      variant="contained"
      onClick={onClick}
      sx={{
        ...typography.body2,
        fontWeight: typography.fontWeightMedium,
        pb: 0.5,
        pt: 0.5,
        paddingInlineStart: 1,
        paddingInlineEnd: 1.5,
        '& .MuiButton-icon': {
          marginInlineStart: 0,
          marginInlineEnd: 1
        },
        '& .PlusIcon-root': { width: spacing(2), height: spacing(2) }
      }}
      startIcon={<PlusIcon className="PlusIcon-root" />}
    >
      {t('filters:filters.new')}
    </Button>
  );
};

export default NewProcessButton;
